module.exports = __webpack_public_path__ + "static/click_heatmap_explore-4e80bf64caab74fce69569bb49f7bbc7.jpg";